import { useState } from 'react'
import { Select, Checkbox } from '@wiggot/web-components'
import { ISelectCombo, ISelectedValue } from '@/interfaces'

export const SelectCombo = ({
  placeholder,
  options,
  label,
  itemLabel,
  itemValue,
  itemActiveLabel,
  onChange,
  isDisabled
}: ISelectCombo) => {
  const [isOpen, setIsOpen] = useState(false)
  const [selectedValue, setSelectedValue] = useState<ISelectedValue>(
    Object.fromEntries(
      options
        ?.filter((option) => option[itemActiveLabel])
        .map((op) => [op[itemValue], op])
    )
  )

  const handleSelectValue = (name: string, value: any) => {
    setSelectedValue((prev: any) => ({
      ...prev,
      [name]: value
    }))
    onChange({ name, value: Boolean(value) })
  }

  return (
    <Select
      placeholder={placeholder}
      isOpen={!isDisabled && isOpen}
      setIsOpen={setIsOpen}
      onClose={() => setIsOpen(false)}
      className="w-full max-w-[345px]"
      value={undefined}
      classNameContainer="min-w-[300px] max-w-[350px]"
      classNameTrigger="h-select-custom"
      isDisabled={isDisabled}
    >
      <Select.Header title={label} />
      <Select.Body className="w-full">
        <div className="w-full flex flex-col py-2 gap-2 items-start justify-center">
          {options?.map((option) => (
            <Checkbox
              key={option[itemValue]}
              label={option[itemLabel]}
              isChecked={
                option[itemValue] ===
                selectedValue[option[itemValue]]?.[itemValue]
              }
              onChange={
                option[itemValue] ===
                selectedValue[option[itemValue]]?.[itemValue]
                  ? () => handleSelectValue(option[itemValue] as any, undefined)
                  : () => handleSelectValue(option[itemValue] as any, option)
              }
              isDisabled={false}
              type="checkbox"
            />
          ))}
        </div>
      </Select.Body>
      <Select.Footer
        className="pb-2"
        optionsCancelButton={{
          className: 'w-full',
          onClick: () => setSelectedValue({})
        }}
        optionsConfirmButton={{
          className: 'w-full',
          onClick: () => setIsOpen(false)
        }}
      />
    </Select>
  )
}
